<!-- eslint-disable max-len -->
<!-- eslint-disable max-lines -->
<template>
    <div class="policy-child-doc">
        <!-- 儿童篇正文对齐 https://p.gsxcdn.com/child_policy.html 首段至「十五个工作日内回复」 -->
        <h1 class="policy-child-doc__title">
            儿童隐私政策
        </h1>
        <p class="policy-child-doc__meta">
            生效日期：2025年12月1日<br>
            最近更新日期：2025年11月24日
        </p>

        <p class="policy-child-doc__intro">
            欢迎您选择由【高途教育科技集团有限公司】（以下简称“我们”）在中国大陆地区开发、运营、提供的相关产品和服务！我们将按照法律法规的规定，保护儿童的个人信息及隐私安全。本《儿童个人信息保护指引》旨在向法定监护人或儿童的父母（以下简称“监护人”）和儿童说明我们如何收集、使用、处理儿童的个人信息，以及控制儿童个人信息的方式。
        </p>

        <section class="policy-child-doc__section">
            <h2>本保护指引将帮助您了解：</h2>
            <ul>
                <li>我们希望监护人与我们共同保护儿童的个人信息，教育、引导儿童增强个人信息保护意识和能力，指导、提醒和要求他们在未经监护人同意的情况下，不向相关产品提供任何个人信息。</li>
                <li>一直以来，我们都高度重视儿童发展，始终坚持儿童利益优先原则。为更好地保护儿童的个人信息，我们会在国家有关未成年人保护相关政策规定的基础上，实施更为严格的保护措施，不断探索新的儿童利益保护技术措施和策略。</li>
                <li>
                    有关儿童或监护人用户的个人信息处理具体情况，请查看本文档下方的《个人信息保护政策》以了解相关信息；若您对该保护指引或其他与个人信息有关的问题有相关疑问，请通过本保护指引公示的联系方式与我们联系。
                </li>
            </ul>
        </section>

        <section class="policy-child-doc__section">
            <h2>1.始终坚持儿童利益优先原则</h2>
            <ul>
                <li><strong>1.1 尊重与保障儿童隐私权：</strong>在保障儿童利益原则指引下，收集与使用的数据均要考虑保护儿童隐私的方式，避免数据的使用侵犯儿童的隐私领域。</li>
                <li><strong>1.2 尊重与保障儿童发展权：</strong>在保障儿童利益原则指引下，收集与使用的数据均需要以保障儿童可以充分发展个性、能力和才华，保障儿童在使用产品的过程能够感受到友爱与温暖。</li>
                <li><strong>1.3 保障儿童的基本安全：</strong>我们将严格遵循《未成年人保护法》等法律法规要求，保障儿童可以了解、参与并实现自身权利，同时不得受到任何形式的侵害与歧视。</li>
            </ul>
        </section>

        <section class="policy-child-doc__section">
            <h2>2.儿童信息的收集、使用</h2>
            <p class="policy-child-doc__subhead">
                2.1 尊重儿童隐私的数据处理
            </p>
            <p class="policy-child-doc__p">
                a.在您的授权同意、用于提供服务所必需或基于法律要求等合法前提下，我们才会要求您和您的被监护人提供合理必要的个人信息。
            </p>
            <p class="policy-child-doc__p">
                b.为了保障您的被监护人在使用我们产品前获得了监护人的有效授权，我们在注册、充值、付费等环节，均需通过手机号码、登录认证等校验措施。
            </p>
            <p class="policy-child-doc__p">
                c. 在您和您的被监护人使用我们的相关产品之前，您需要提供创建账户所需的信息；在企业级帐户中，您也可能会被我们的合作方（如学校）要求提供创建账户所需的信息，我们会基于合作方的要求收集、处理、共享您或您的被监护人的相关数据。您可以从具体产品或服务的隐私政策中查看具体的信息收集内容。
            </p>
            <p class="policy-child-doc__p">
                d.请您注意，当您或您的被监护人与他人分享照片、视频、音频、和位置等各种信息时，其他人可能通过分享渠道或公开渠道搜索到这些可能涉及儿童的信息，请您在分享这些信息前注意保护儿童的相关隐私，并充分考虑这些数据分享后可能给儿童带来的影响。
            </p>
            <p class="policy-child-doc__p">
                e.为了保障服务所必需，我们可能会与关联公司或合作方共享相关服务所必需的数据。我们会按照法律法规的要求、技术规范以及任何适当的保密和安全措施进行上述合作。
            </p>
            <p class="policy-child-doc__subhead">
                2.2 尊重与保障儿童发展的数据处理
            </p>
            <p class="policy-child-doc__p">
                a. 如不同产品的隐私政策中所述，通常情况下，我们会运用您和您的被监护人的信息以开发新服务、评估产品或服务效果以及了解产品或服务的使用情况等，有时我们也会在您的明确授权同意下与您或您的被监护人沟通产品或服务的相关事宜，以更好地为您和您的被监护人服务。
            </p>
            <p class="policy-child-doc__p">
                b.为保障儿童不被商业信息所困扰，我们不会在儿童帐号中加入任何网络游戏链接，也不会推送与教学无关的广告信息。
            </p>
            <p class="policy-child-doc__subhead">
                2.3 用于保障儿童的基本安全的数据处理
            </p>
            <ul>
                <li>为了预防系统中的数据滥用行为、监测恶意软件或不法人员通过站内信等方式在系统内发送非法内容，我们会使用相关技术来识别相关数据，以保护儿童合法利益。如果我们的系统检测到违反法律法规或者政策规范的恶意软件、非法内容或其他形式的滥用行为，我们可能会停用相关账号或采取其他适当措施。</li>
            </ul>
        </section>

        <section class="policy-child-doc__section">
            <h2>3.联系我们</h2>
            <ul>
                <li>如果您对您的被监护人的帐号、使用产品和服务的情况或其他方面有任何疑问，欢迎您随时与我们联系：</li>
            </ul>
            <ul class="policy-child-doc__list--circle">
                <li>电子邮件：<a class="policy-child-doc__link" href="mailto:feihua-service@baijia.com">feihua-service@baijia.com</a></li>
                <li>电话：<a class="policy-child-doc__link" href="tel:18161022605">18161022605</a></li>
            </ul>
            <p class="policy-child-doc__p">
                我们将尽快审核所涉问题，并在验证您的用户身份后的十五个工作日内回复。
            </p>
        </section>
    </div>
</template>

<script>
export default {
    name: 'ChildPrivacyPolicy20251124Content',
};
</script>
